var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_609_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4303 4.50353L18.1603 2.30383C17.6103 1.3512 16.3808 1.02178 15.4282 1.57178L1.5718 9.57178C0.619175 10.1218 0.293412 11.3375 0.848412 12.2988L2.11841 14.4985C2.46341 15.0961 3.0892 15.52 3.77748 15.4921C4.49807 15.4802 5.1918 15.8418 5.5718 16.5C5.9518 17.1582 5.91441 17.9534 5.53382 18.5542C5.1792 19.14 5.22475 19.8989 5.56975 20.4964L6.83975 22.6961C7.38975 23.6488 8.61918 23.9782 9.5718 23.4282L23.4282 15.4282C24.3808 14.8782 24.7103 13.6488 24.1603 12.6961L22.8903 10.4964C22.5453 9.89887 21.9108 9.47997 21.2262 9.49419C20.5106 9.51474 19.8082 9.15816 19.4282 8.49998C19.0482 7.8418 19.0906 7.05522 19.4662 6.44578C19.8208 5.85999 19.7753 5.10109 19.4303 4.50353ZM16.116 16.7631L14.384 17.7631L13.384 16.0311L15.116 15.0311L16.116 16.7631ZM13.866 12.866L12.134 13.866L11.134 12.134L12.866 11.134L13.866 12.866ZM11.616 8.96889L9.88398 9.96889L8.88398 8.23684L10.616 7.23684L11.616 8.96889Z",
    fill: "#611180"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_609_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/TicketIcon.374a770dbeaeff8b992cde23975feb52.svg";
export { ForwardRef as ReactComponent };